// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607100303/js/" + chunkId + "." + {"44":"32a2fcf9","225":"cf9f477a","481":"5790ce2d","486":"96f4db3b","770":"caf15259"}[chunkId] + ".0.20435729195865393.chunk.js";
};